import { Button } from "@/components/ui/button"
import type { ChallengeActivity } from "@/services/api/odin/activities/challenge/study-session/update"

interface ChallengeFeedbackFooterProps {
  activity: ChallengeActivity
  onRetry: () => void
  onContinueStudying: () => void
}

export default function ChallengeFeedbackFooter({
  activity,
  onRetry,
  onContinueStudying,
}: ChallengeFeedbackFooterProps) {
  const isApproved = activity.feedback.scorePercentage >= activity.feedback.approvalScore
  return (
    <footer className="flex w-full max-w-4xl px-4 pb-4">
      <div className="mx-auto flex w-full flex-col items-center gap-3">
        {isApproved ? (
          <Button size="lg" className="w-full" onClick={onContinueStudying}>
            Continuar estudiando
          </Button>
        ) : (
          <>
            <Button size="lg" className="w-full" onClick={onRetry}>
              Reintentar
            </Button>
            <Button size="lg" variant="outline" className="w-full" onClick={onContinueStudying}>
              Continuar estudiando
            </Button>
          </>
        )}
      </div>
    </footer>
  )
}
